"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Switch = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _Switch = require("./Switch.styled");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _excluded = ["labelText", "id", "disabled", "data-testid", "aria-labelledby", "aria-describedby", "className"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
/**
 * @description This component uses the same props as a native checkbox, but it is styled as a switch.
 * @param labelText
 * @param id
 * @param disabled
 * @param dataTestId
 * @param ariaLabelledBy
 * @param ariaDescribedBy
 * @param className
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
var Switch = exports.Switch = /*#__PURE__*/(0, _react.memo)(function (_ref) {
  var labelText = _ref.labelText,
    id = _ref.id,
    disabled = _ref.disabled,
    dataTestId = _ref['data-testid'],
    ariaLabelledBy = _ref['aria-labelledby'],
    ariaDescribedBy = _ref['aria-describedby'],
    className = _ref.className,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Switch.StyledWrapper, {
    disabled: disabled,
    "data-testid": dataTestId,
    className: className
  }, /*#__PURE__*/_react["default"].createElement(_Switch.StyledSwitch, null, labelText && /*#__PURE__*/_react["default"].createElement(_Switch.StyledSwitchCheckboxLabel, {
    labelFor: id,
    label: labelText
  }), /*#__PURE__*/_react["default"].createElement(_Switch.StyledSwitchCheckbox, (0, _extends2["default"])({
    disabled: disabled,
    id: id,
    type: "checkbox",
    className: "switch"
  }, ariaLabelledBy && {
    'aria-labelledby': ariaLabelledBy
  }, ariaDescribedBy && {
    'aria-describedby': ariaDescribedBy
  }, props, {
    "data-testid": "".concat(dataTestId, "_checkbox")
  }))));
});
Switch.propTypes = {
  labelText: _propTypes["default"].string,
  id: _propTypes["default"].string,
  className: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  'data-testid': _propTypes["default"].string,
  'aria-labelledby': _propTypes["default"].string,
  'aria-describedby': _propTypes["default"].string
};